export default {"src":"/_next/static/media/search.6ba176ac.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};